import getWithToken from './base/get-with-token'

const getWaterSupply = getWithToken(`/report/water-supply`)

export default getWaterSupply
